export default __webpack_public_path__ + "static/media/white-left-arrow.f7c13300.svg";